import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { ModalEnum } from 'myParkdUtils/enums';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import * as myParkdSettingsActions from 'features/settings/myParkdSettingsActions';
import * as feedbackActions from 'features/support/feedbackActions';
import { GAAction, GACategory, trackDataLayerEvent } from 'myParkdUtils/googleAnalytics';
import { ReduxState } from 'types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import TagManager from 'react-gtm-module';


type RatingStarProps = {
    starsHovered: number,
    starNum: number,
    starRating: number,
    onStarsHover: Function,
    updateRating: Function
}

const RatingStar = (props: RatingStarProps) => (
    <li
        className={props.starsHovered > props.starNum || props.starRating > props.starNum ? 'hover' : 'a'}
        onMouseOver={() => props.onStarsHover(props.starNum + 1)}
        onClick={() => props.updateRating(props.starNum + 1)}
    >
        <FontAwesomeIcon icon={faStar} size='lg' />
    </li>
);

const StarRatingBox = (props: Props) => {
    const [starRating, setStarRating] = useState<number>(0);
    const [starsHovered, setStarsHovered] = useState<number>(0);

    useEffect(() => {
        if (props.feedbackStatus.sent && props.feedbackStatus.hasStarRating) {
            hideStarRatingBox();
        }
    }, [props.feedbackStatus.sent, props.feedbackStatus.hasStarRating]);

    async function saveStarRating() {
        const starRatingData = `starRating: ${starRating}/5\ncompanyName: ${props.companyDetails.name} \ncompanyId: ${props.companyDetails.id}`;
        if (starRating <= 2) {
            props.openModal(ModalEnum.SEND_FEEDBACK_TO_SUPPORT, starRatingData);
        } else {
            props.sendFeedbackToSupport({
                message: '',
                starRatingData: starRatingData
            });
        }
        trackDataLayerEvent({ event: GAAction.STAR_RATING, rating: starRating })
    }

    function hideStarRatingBox() {
        props.updateMyParkdSetting('starRatingBoxIsHidden', true, props.userId);
    }

    return props.myParkdSettings && props.myParkdSettings.starRatingBoxIsHidden ? null : (
        <div className="star-rating-box radius-corners center">
            <div id="rating-stars" onMouseOut={e => setStarsHovered(0)}>
                <ul>
                    {[...Array(5)].map((star, i) => (
                        <RatingStar
                            key={i}
                            starNum={i}
                            starsHovered={starsHovered}
                            starRating={starRating}
                            onStarsHover={(starsHovered: number) => setStarsHovered(starsHovered)}
                            updateRating={(rating: number) => setStarRating(rating)}
                        />
                    ))}
                </ul>
            </div>

            <div className='center'>
                <p className="rating-title">
                    <FormattedMessage id="STAR_RATING_HOW_ARE_YOU_FINDING_PARKD" />
                </p>
            </div>

            <button
                className={'btn-blue full-width' + (props.feedbackStatus.isSending ? ' saving' : '')}
                onClick={saveStarRating}
            >
                <FormattedMessage id="STAR_RATING_BTN_RATE" />
                <div className="spinner">
                    <div className="cube1" />
                    <div className="cube2" />
                </div>
            </button>
        </div>
    );
};


type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps;


function mapStateToProps(state: ReduxState) {
    return {
        myParkdSettings: state.myParkdSettings[state.user?.user?.id],
        companyDetails: state.companyDetails?.companyDetails,
        feedbackStatus: state.feedback?.feedbackStatus,
        userId: state.user?.user?.id,
        auth: state.auth
    };
}

function mapDispatchToProps(dispatch: any) {
    return bindActionCreators(
        {
            openModal: modalWindowActions.updateModalWindow,
            updateMyParkdSetting: myParkdSettingsActions.updateMyParkdSetting,
            sendFeedbackToSupport: feedbackActions.sendFeedbackToSupport
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(StarRatingBox);